export default __webpack_public_path__ + "static/media/logo.0cda75b2.svg";